import React from 'react';
import About from '../components/About';

export default function AboutPage() {
  return (
    <div className="pt-20">
      <About />
    </div>
  );
}
